import React, { FunctionComponent } from 'react';

import { useTranslation } from 'react-i18next';

import { ReplyProps } from 'reviews2/feed/review-yeti/reply/ReviewReply.types';
import { hashTagParser, mentionParser } from 'reviews2/feed/review-yeti/Review.util';
import { Collage } from 'social/common/collage/Collage';

import 'reviews2/feed/review-yeti/reply/content/ReplyContent.scss';

const MAX_MEDIA_COUNT = 4;
const SUPPORTED_MEDIA_REGEX = /photo|sticker|video/i;

export const ReplyContent: FunctionComponent<ReplyProps> = ({ reply }) => {
    const { t } = useTranslation('reviews2');
    const textWithMentions = mentionParser(reply.sanitized_text, reply.r4e_mentions);
    const textWithHashTags = hashTagParser(textWithMentions, reply.review_source_id);
    const supportedMedia = reply.expanded_post_media?.filter((media: any) => SUPPORTED_MEDIA_REGEX.test(media.format));
    const unsupportedMedia = reply.expanded_post_media?.filter(
        (media: any) => SUPPORTED_MEDIA_REGEX.test(media.format) === false,
    );

    if (!textWithHashTags && !reply.expanded_post_media?.length) {
        return null;
    }

    return (
        <div className="reply-content">
            {/* eslint-disable-next-line react/no-danger */}
            <div className="reply-content-text" dangerouslySetInnerHTML={{ __html: textWithHashTags }} />
            {supportedMedia?.length ? (
                <div className="r4e-review-medias">
                    <Collage
                        openModalOnMediaClick
                        maxCount={MAX_MEDIA_COUNT}
                        galleryData={supportedMedia?.map((media: any) => {
                            return {
                                url: media.url || media.media_url,
                                type: /photo|sticker$/i.test(media.format) ? 'image' : 'video',
                            };
                        })}
                    />
                </div>
            ) : null}
            {unsupportedMedia?.length ? (
                <div className="unsupported-media">
                    {t('REPLY_UNSUPPORTED_MEDIA_COUNT', { count: unsupportedMedia.length })}
                </div>
            ) : null}
        </div>
    );
};
